module.exports = __webpack_public_path__ + "static/media/Picture8.54db8fe0.jpg";